export default __webpack_public_path__ + "static/media/asteroids.12bc13f0.jpg";